import { render, staticRenderFns } from "./OtDisplay.vue?vue&type=template&id=d8130e46&scoped=true&"
import script from "./OtDisplay.vue?vue&type=script&lang=js&"
export * from "./OtDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OtDisplay.vue?vue&type=style&index=0&id=d8130e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8130e46",
  null
  
)

export default component.exports